import { useState } from 'react';
import './Blog.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import Popup from '../../components/Popup';
import Image from './1.jpg';

const BlogPage = () => {
  const navigate = useNavigate();
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className='page'>
      <Header />
      <div className='blogPageMainScreen'>
        <div className='blogPageMainScreenContent'>
          <span className='blogPageMainScreenBack' onClick={() => navigate('/blog')}>
            <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
              <path
                d='M7.9987 12.6667L3.33203 7.99999M3.33203 7.99999L7.9987 3.33333M3.33203 7.99999H12.6654'
                stroke='#3A6376'
                stroke-width='1.33'
                stroke-linecap='round'
                stroke-linejoin='round'
              />
            </svg>
            Back to Articles
          </span>
          <h1 className='blogPageMainScreenTitle'>The 50 Mile Myth for Travelers</h1>
          <span className='blogPageMainScreenDate'>November 15, 2025</span>
          <div className='blogPageMainScreenImage'>
            <img src={Image} />
          </div>
        </div>
      </div>
      <div className='blogPageContent'>
        <p>
          Probably one of the most common misconceptions we hear, specifically for travelers, is the ‘50 Mile Rule’ regarding tax
          free stipends. This topic is often discussed and easily accepted as truth among travelers, no matter how many times it’s
          refuted. This ‘rule’ claims that employees can accept tax-free stipends as part of their travel pay if their assignment
          is 50 miles or more from their tax home. The IRS doesn’t make this determination, and the reality is the ‘50 Mile Rule’
          for travelers doesn’t exist.
        </p>
        <h3>So how did the ’50 Mile Rule’ come to be?</h3>
        <p>
          There are at least three possible causes for this misconception. The first being that a 50 Mile Rule does exist for
          state legislators, and is used to determine if they can accept per diem payments while away from home. Another possible
          cause for this misconception is the IRS requires a taxpayer’s new commute to work be more than 50 miles than their old
          commute to write off moving deductions. The third possible origin of this myth relates directly to travelers. Many
          travel companies add the ‘50 Mile Rule’ verbiage as part of their internal policy and contracts—and this is done so
          often, many accept this as an IRS regulation. Some hospitals who employ travelers also may impose this rule even though
          it the IRS did not establish it, adding to the false impression of legitimacy of the idea.
        </p>
        <h3>How far is far enough for a travel assignment?</h3>
        <p>
          There isn’t a mileage requirement for travelers to qualify for tax-free money. The IRS allows for tax-free
          reimbursements for lodging, meals and incidental expenditures when the employee needs to sleep or rest to meet the
          demands of the position while away from their tax home. It’s not the distance from your tax home, but what you do at the
          end of your shift that determines if you qualify. It’s important to note that if you work a travel contract and return
          home at the end of each shift, regardless of mileage, all tax-free per diems or stipends are then considered taxable
          income. Just because you could have traveling expenses doesn’t mean you will be reimbursed. You must incur the actual
          expenses to qualify.
        </p>
        <h3>How do I know if I qualify for tax-free reimbursements?</h3>
        <p>
          If you’re planning to work travelers’ positions, you need to make sure you understand how the IRS recognizes temporary
          travel employment. Below are some general factors that contribute to receiving tax-free stipends.
        </p>
        <ul>
          <li>
            <b>You must be working away from your tax-home.</b> The IRS considers your tax-home to be your main place of business,
            not necessarily your family home. This distinction is important, because if you spend most your work time in one
            location, your tax-home will shift to that location. Frequent employment moves are required to maintain your
            “temporary status” and make sure your tax-home doesn’t shift.
          </li>
          <li>
            <b>Your living expenses are duplicated because of traveling for work.</b> This factor doesn’t involve a specific
            amount, but as mentioned earlier, you must incur the expense to qualify. Just because you could have traveling
            expenses, doesn’t mean you’ll be reimbursed without documentation that the expenses occurred.
          </li>
          <li>
            <b>You must maintain your status as a temporary worker.</b> In defining temporary work, IRS Publication 463 claims if
            you expect an assignment to last for one year or less, it is considered temporary. The position can first be temporary
            but then be considered indefinite based on changed circumstances—so it’s important to review your contracts. You
            should ensure they have specific start and end dates. This will provide proof of your temporary status.
          </li>
        </ul>
        <h3>Should I travel?</h3>
        <p>
          We understand there are many factors that are involved when considering becoming a traveler in the healthcare industry.
          The worry that your travel assignments will not qualify unless they are over 50 miles away should not be one of them. We
          understand there are quite a few factors that are required to qualify for tax-free stipends as a traveler. We hope that
          you will take some time to read the actual IRS Revenue Ruling 73-29 for the specific language and expectations
          surrounding travel expenses. If you have additional questions about travel assignments or would like to discuss
          available openings, don’t hesitate to contact us for more information.
        </p>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <Footer />
    </div>
  );
};

export default BlogPage;
